import {all, call, put, takeLatest} from 'redux-saga/effects';
import * as constants from '../constants';
import * as api from '../services/api';
import {logout} from '../actions/action_auth';
import * as actions from '../actions/action_organization';

function* fetch() {
    try {
        const response = yield call(api.fetchOrganization);
        yield put(actions.organizationSuccess(response.data));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.organizationFailure(error));
    }
}

function* edit({payload}) {
    try {
        const response = yield call(api.editOrganization, payload.item);
        yield put(actions.organizationSuccess(response.data));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.organizationFailure(error));
    }
}


export default function* root() {
    yield all([
        takeLatest(constants.ORGANIZATION_REQUESTED, fetch),
        takeLatest(constants.ORGANIZATION_EDIT_REQUESTED, edit),
    ]);
}
